import { createBlockHandler } from './createBlockHandler'
import { deleteBlockHandler } from './deleteBlockHandler'
import { updateBlockHandler } from './updateBlockHandler'

export const formBlockMethods = {
  create: createBlockHandler,
  delete: deleteBlockHandler,
  update: updateBlockHandler,
}
